import { createContext, useContext, type ReactNode } from "react";

export type MdxArticleLinkContextValue = {
  onArticleSelect: (slugOrId: string) => void;
};

const MdxArticleLinkContext = createContext<MdxArticleLinkContextValue | null>(
  null
);

export type Props = {
  onArticleSelect: (slugOrId: string) => void;
  children: ReactNode;
};

export function MdxArticleLinkProvider({ onArticleSelect, children }: Props) {
  return (
    <MdxArticleLinkContext.Provider value={{ onArticleSelect }}>
      {children}
    </MdxArticleLinkContext.Provider>
  );
}

export function useMdxArticleLink(): MdxArticleLinkContextValue | null {
  return useContext(MdxArticleLinkContext);
}

export default MdxArticleLinkProvider;
